import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaAppuntamentiComponent } from './companies/ListaAppuntamenti/lista-appuntamenti.component';
import { FullLayoutComponent } from './containers';
import { AuthGuard } from './guards/AuthGuard';
import { PageAccessGuard } from './guards/PageAccessGuard';
import { ProfiloComponent } from './portale/Profilo/profilo.component';
import { P404Component } from './views/pages/404.component';
import { P503Component } from './views/pages/503.component';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./views/pages/pages.module').then((m) => m.PagesModule),
	},
	{
		path: 'login_due_fattori',
		loadChildren: () => import('./views/pages/pages.module').then((m) => m.PagesModule),
	},
	{
		path: 'reset_password',
		loadChildren: () => import('./portale/reset_password/reset_password.module').then((m) => m.ResetPasswordModule),
	},
	{
		// Pagina pubblica per la richiesta di eliminazione account/dati (requisito Google Play)
		path: 'eliminazione-account',
		loadComponent: () => import('./portale/eliminazione-account/eliminazione-account.component').then((m) => m.EliminazioneAccountComponent),
	},
	{
		path: '',
		canActivate: [AuthGuard],
		canActivateChild: [PageAccessGuard],
		component: FullLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
			},
			{
				path: 'portale',
				loadChildren: () => import('./portale/portale.module').then((m) => m.PortaleModule),
				data: {
					title: '',
				},
			},
			{
				path: 'sezione_documentale',
				loadChildren: () => import('./sezione-documentale/sezione-documentale.module').then((m) => m.SezioneDocumentalePageModule),
			},
			{
				path: 'companies',
				loadChildren: () => import('./companies/companies.module').then((m) => m.CompaniesModule),
				data: {
					title: 'menu.companies',
				},
			},
			{
				path: 'mail',
				loadChildren: () => import('./mail/mail.module').then((m) => m.MailModule),
				data: {
					title: 'Email',
				},
			},
			{
				path: 'mail-settings',
				loadChildren: () => import('./mail/settings/mail-settings.module').then((m) => m.MailSettingsModule),
				data: {
					title: 'Impostazioni Email',
				},
			},
			{
				path: 'worksite',
				loadChildren: () => import('./companies/Worksite/worksite.module').then((m) => m.WorksiteModule),
			},
			{
				path: 'gare',
				loadChildren: () => import('./companies/Gare/gare.module').then((m) => m.GareModule),
			},
			{
				// Report campagna CNA. La visibilità è governata dai permessi pagina del
				// portale (prt_page /campagna-cna + prt_roles_page sul ruolo CNA_REPORT):
				// chi non ha il permesso non vede la voce in sidebar, e l'endpoint dati
				// risponde 403 anche se la rotta viene aperta a mano.
				path: 'campagna-cna',
				loadChildren: () => import('./campagna-cna/campagna-cna.module').then((m) => m.CampagnaCnaModule),
				data: {
					title: 'Campagna CNA',
				},
			},
			{
				path: 'appointments',
				component: ListaAppuntamentiComponent,
			},
			{
				path: 'records',
				loadChildren: () => import('./companies/Attendance/attendance.module').then((m) => m.AttendanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'records',
				loadChildren: () => import('./companies/Attendance/attendance.module').then((m) => m.AttendanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'workflow',
				loadChildren: () => import('./workflow/workflow.module').then((m) => m.WorkflowModule),

				data: {
					title: '',
				},
			},
			{
				path: 'activity',
				loadChildren: () => import('./activity/activity.module').then((m) => m.ActivityModule),
				data: {
					title: '',
				},
			},
			{
				path: 'instance',
				loadChildren: () => import('./instance/instance.module').then((m) => m.InstanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'report',
				loadChildren: () => import('./report_utility/report-utility.module').then((m) => m.ReportUtilityModule),
				data: {
					title: '',
				},
			},
			{
				path: 'ticketsrfi',
				loadChildren: () => import('./helpdesk_rfi/tickets/tickets.module').then((m) => m.TicketsModule),
				data: {
					title: '',
				},
			},
			{
				path: 'profile',
				component: ProfiloComponent,
				data: {
					title: 'Profilo',
				},
			},
			{
				path: 'hr',
				loadChildren: () => import('./HR/hr.module').then((m) => m.HRModule),
				data: {
					title: '',
				},
			},
			{
				path: 'automezzi',
				loadChildren: () => import('./automezzi/automezzi.module').then((m) => m.AutomezziModule),
				data: {
					title: 'Automezzi',
				},
			},
			{
				path: 'magazzino',
				loadChildren: () => import('./magazzino/magazzino.module').then((m) => m.MagazzinoModule),
				data: {
					title: 'Magazzino',
				},
			},
			{
				path: 'fatture',
				loadChildren: () => import('./fatture/fatture.module').then((m) => m.FattureModule),
				data: {
					title: 'Fatture',
				},
			},
			{
				path: 'documenti',
				loadChildren: () => import('./documenti/documenti.module').then((m) => m.DocumentiModule),
				data: {
					title: 'label.documenti.titolo',
				},
			},
			{
				path: 'biz-appointments',
				loadChildren: () => import('./biz-appointments/biz-appointments.module').then((m) => m.BizAppointmentsModule),
				data: {
					title: 'Appuntamenti',
				},
			},
			{
				path: 'recensioni',
				loadChildren: () => import('./recensioni/recensioni.module').then((m) => m.RecensioniModule),
				data: {
					title: 'Recensioni',
				},
			},
			{
				path: 'assemblee',
				loadChildren: () => import('./assemblee/assemblee.module').then((m) => m.AssembleeModule),
				data: {
					title: 'assemblee.titolo',
				},
			},
			{
				path: 'sopralluoghi',
				loadChildren: () => import('./sopralluoghi/sopralluoghi.module').then((m) => m.SopralluoghiModule),
				data: {
					title: 'sopralluoghi.titolo',
				},
			},
			{
				// niente title: i breadcrumb li definiscono le rotte interne del modulo
				// (la radice punterebbe sempre alla lista, sbagliato per le impostazioni)
				path: 'preventivi-serramenti',
				loadChildren: () => import('./preventivi-serramenti/preventivi-serramenti.module').then((m) => m.PreventiviSerramentiModule),
			},
			{
				path: 'fotovoltaico',
				loadChildren: () => import('./fotovoltaico/fotovoltaico.module').then((m) => m.FotovoltaicoModule),
				data: {
					title: 'Impianti Fotovoltaici',
				},
			},
			{
				path: 'messaging',
				loadChildren: () => import('./messaging/messaging.module').then((m) => m.MessagingModule),
				data: {
					title: 'Messaggi',
				},
			},
			{
				path: 'notifications',
				loadChildren: () => import('./notifications/notifications.module').then((m) => m.NotificationsModule),
				data: {
					title: 'Notifiche',
				},
			},
			{
				path: 'style-guide',
				loadChildren: () => import('./style-guide/style-guide.module').then((m) => m.StyleGuideModule),
				data: {
					title: 'Style Guide',
				},
			},
			{
				path: 'prezziario-primus',
				loadChildren: () => import('./prezziario-primus/prezziario-primus.module').then((m) => m.PrezziarioPrimusModule),
				data: {
					title: 'Prezziario PriMus',
				},
			},
			{
				path: 'listini-prezzi',
				loadChildren: () => import('./listini-prezzi/listini-prezzi.module').then((m) => m.ListiniPrezziModule),
				data: {
					title: 'Listini prezzi',
				},
			},
			{
				path: 'prenotazioni',
				loadChildren: () => import('./prenotazioni/prenotazioni.module').then((m) => m.PrenotazioniModule),
				data: {
					title: 'Prenotazioni',
				},
			},
			{
				path: 'colazioni-scuola',
				loadChildren: () => import('./colazioni-scuola/colazioni-scuola.module').then((m) => m.ColazioniScuolaModule),
				data: {
					title: 'Colazioni a scuola',
				},
			},
			{
				path: 'pagamento',
				loadChildren: () => import('./pagamento/pagamento.module').then((m) => m.PagamentoModule),
				data: {
					title: 'Pagamento',
				},
			},
			{
				path: 'cel',
				loadChildren: () => import('./companies/Cel/cel.module').then((m) => m.CelModule),
				data: {
					title: 'CEL',
				},
			},
			{
				path: 'sub-aff',
				loadChildren: () => import('./companies/SubAff/sub-aff.module').then((m) => m.SubAffModule),
				data: { title: 'Sub-Affidamenti' },
			},
			{
				path: 'sal',
				loadChildren: () => import('./companies/Sal/sal.module').then((m) => m.SalModule),
				data: { title: 'SAL' },
			},
			{
				path: 'sal-passivo',
				loadChildren: () => import('./companies/SalPassivo/sal-passivo.module').then((m) => m.SalPassivoModule),
				data: { title: 'SAL Passivi' },
			},
			{
				// Cert. Pagamento — modulo unificato: stesso componente del flusso RFI
				// ma con mode='portale' → backend federato (ws_spring_cmp/cert-payment) e vista federata
				path: 'cert-payment',
				loadChildren: () => import('./helpdesk_rfi/tickets/certificati_pagamento/certificati_pagamento.module').then((m) => m.CertificatiPagamentoModule),
				data: { title: 'Certificati Pagamento', mode: 'portale' },
			},
			{
				// Cruscotto della sezione a schede Commesse (menu-hub.ts): voce di menu generata dal portale,
				// la guardia lo apre a chi vede almeno una delle pagine della sezione
				path: 'commesse',
				loadComponent: () => import('./companies/Commesse/commesse-cruscotto.component').then((m) => m.CommesseCruscottoComponent),
				data: { title: 'Commesse' },
			},
			{
				// Cruscotto della sezione a schede Finanza aziendale (menu-hub.ts): voce generata accanto a Fatture,
				// la guardia lo apre a chi vede Fatture
				path: 'finanza',
				loadComponent: () => import('./fatture/finanza/finanza-cruscotto.component').then((m) => m.FinanzaCruscottoComponent),
				data: { title: 'Finanza aziendale' },
			},
			{
				// Gestione Contratti — versione portale/companies (backend ws_spring_cmp/cert-payment-contracts).
				// La versione RFI (/ticketsrfi/gestione_contratti) resta separata e invariata.
				path: 'gestione-contratti',
				loadChildren: () => import('./companies/Contratti/contratti.module').then((m) => m.ContrattiModule),
				data: { title: 'Gestione Contratti', mode: 'portale' },
			},
			{
				path: 'onlineshop',
				loadChildren: () => import('./onlineshop/onlineshop.module').then((m) => m.OnLineShopModule),
				data: {
					title: 'OnlineShop',
				},
			},
			{
				path: 'bacheca',
				loadChildren: () => import('./eventboard/eventboard.module').then((m) => m.EventboardModule),
				data: {
					title: 'Bacheca',
				},
			},
			{
				path: 'turismo',
				loadChildren: () => import('./turismo/turismo.module').then((m) => m.TurismoModule),
				data: {
					title: 'Turismo',
				},
			},
		],
	},
	{
		path: '404',
		component: P404Component,
	},
	{
		path: '503',
		component: P503Component,
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
